import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { AzureCosmosDbMongoDbApiDataset } from 'app/model/dataset/azure-cosmos-db-mongodb-api.dataset';
import {
    TabularTypeDatasetAdapter,
    tabularPropertiesCommonAdapts
} from 'app/model/adapters/datasets/tabular-type.dataset.adapter';
import { HierarchicalNode } from 'app/model/dataset/hierarchicalnode';
import { parseJsonSchema } from './json.dataset.adapter';
import { ValueAdapter } from '../value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureCosmosDbMongoDbApiDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            version: __IS_FABRIC_DPE__ ? '*' : undefined,
            typeProperties: {
                database: __IS_FABRIC_DPE__ ? '*' : undefined,
                collection: '*'
            }
        }
    }
})
export class AzureCosmosMongoDbApiDatasetAdapter extends TabularTypeDatasetAdapter<
    AzureCosmosDbMongoDbApiDataset,
    Model.DatasetResource
> {
    public parseHierarchicalSchema(obj: object): HierarchicalNode {
        return parseJsonSchema(obj);
    }

    protected async _toResource(dataset: AzureCosmosDbMongoDbApiDataset): Promise<Model.DatasetResource> {
        const modelDataset = await this._toResourceInternal(
            dataset,
            Metamodel.modelFor(AzureCosmosDbMongoDbApiDataset).name,
            'collection',
            undefined,
            undefined,
            undefined,
            (__IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric) ? AzureCosmosDbMongoDbApiDataset.DATABASE : undefined
        );

        if (__IS_FABRIC_DPE__) {
            modelDataset.properties.version = ValueAdapter.toResource(dataset, AzureCosmosDbMongoDbApiDataset.VERSION);
        }

        return modelDataset;
    }

    protected async _toModel(
        modelDatasetResource: Model.DatasetResource,
        dataset?: AzureCosmosDbMongoDbApiDataset
    ): Promise<AzureCosmosDbMongoDbApiDataset> {
        dataset = await this._toModelInternal(
            modelDatasetResource,
            dataset,
            AzureCosmosDbMongoDbApiDataset.MODEL,
            'collection',
            undefined,
            undefined,
            undefined,
            (__IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric) ? AzureCosmosDbMongoDbApiDataset.DATABASE : undefined
        );

        if (__IS_FABRIC_DPE__) {
            dataset.version = undefined;
            ValueAdapter.toModel(
                dataset,
                AzureCosmosDbMongoDbApiDataset.VERSION,
                modelDatasetResource.properties?.version
            );
        }

        return dataset;
    }
}
